import React, { Component } from 'react'
import masthead from '../../assets/img/sergio-souza-tncsQE63ENU-unsplash.jpg';
import Select from 'react-select/async';

export default class Search extends Component {

  state = {
    busca: '',
    territorios: []
  }

  componentDidMount() {
    const ts = require('../../../data/territorios.json');
    this.setState({
      territorios: ts.map((t) => {
        return { value: t, label: `${t.nome} ${t.codigo.length > 2 ? '- ' + t.uf : t.codigo.length === 2 ? '(Estado)' : ''}` };
      })
    });
  }

  filtrarTerritorios(i, c) {
    if (i.length <= 2)
      return c([]);
    i = i.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    const r = new RegExp(i, 'igm');
    return c(this.state.territorios.filter(t => r.test(t.label.normalize("NFD").replace(/[\u0300-\u036f]/g, ""))).sort((a,b) => a.label > b.label ? 1 : -1));
  }

  onInputChange(value) {
    this.setState({ busca: value });
    return value;
  }

  onChange(v) {
    window.location.href = `/data?codigo=${v.value.codigo}&nome=${v.value.nome}&uf=${v.value.uf ?? ''}&estado=${v.value.estado ?? ''}`;
  }

  noOptionsMessage() {
    if (this.state.busca.length <= 2)
      return "Sua busca deve possuir no mínimo 3 letras.";
    else
      return "Nenhum território encontrado com o termo da busca.";
  }

  render() {
    return (
      <>
        <header
          className="masthead text-white text-center"
          style={{
            backgroundPosition: 'center center',
            backgroundRepeat: 'no-repeat',
            backgroundSize: "cover",
            backgroundImage: `url(${masthead})`
          }}
        >
          <div className="overlay" />
          <div className="container">
            <div className="row">
              <div className="col-xl-9 mx-auto">
                <h1 className="mb-5">
                  Todos os dados governamentais compilados em um único lugar
          </h1>
              </div>
              <div className="col-md-10 col-lg-8 col-xl-7 mx-auto">
                <form>
                  <div className="form-row">
                    <div className="col-12 mb-2 mb-md-0">
                      <Select
                        className="text-dark"
                        onChange={this.onChange.bind(this)}
                        cacheOptions
                        loadOptions={this.filtrarTerritorios.bind(this)}
                        defaultOptions
                        onInputChange={this.onInputChange.bind(this)}
                        noOptionsMessage={this.noOptionsMessage.bind(this)}
                        placeholder={'Procure por uma cidade, estado ou região...'} />
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </header>
        <section className="text-right bg-light">
          <small className="pr-3">
            Foto de&nbsp;
      <a href="https://unsplash.com/@serjosoza?utm_source=unsplash&utm_medium=referral&utm_content=creditCopyText">
              Sergio Souza
      </a>
      &nbsp;no&nbsp;
      <a href="https://unsplash.com/?utm_source=unsplash&utm_medium=referral&utm_content=creditCopyText">
              Unsplash
      </a>
      .<br />
          </small>
        </section>
      </>
    )
  }
}
